const state = () => ({
  isAdvancedAvailabilityLoading: false,
  advancedAvailability: {},
  requestQueue: []
})

const mutations = {
  setAdvancedAvailability (state, { availability, variationId }) {
    state.advancedAvailability[variationId] = availability
  },
  setIsAdvancedAvailabilityLoading (state, isLoading) {
    state.isAdvancedAvailabilityLoading = isLoading
  },
  addToRequestQueue (state, variationId) {
    if (!state.requestQueue.includes(variationId)) {
      state.requestQueue.push(variationId)
    }
  },
  clearRequestQueue (state) {
    state.requestQueue = []
  }
}

const actions = {
  async loadAdvancedItemAvailability ({ commit, state }, variationId) {
    if (state.advancedAvailability[variationId]) {
      return
    }

    commit('addToRequestQueue', variationId)

    if (!state.isAdvancedAvailabilityLoading) {
      commit('setIsAdvancedAvailabilityLoading', true)

      await new Promise((resolve) => setTimeout(resolve, 50))

      const batchVariationIds = [...state.requestQueue]
      commit('clearRequestQueue')

      try {
        const response = await fetch('/rest/wwmoa/delivery', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ variationIds: batchVariationIds })
        })

        if (!response.ok) throw new Error('Network response was not ok')

        const responseData = await response.json()
        if (responseData?.data) {
          responseData.data.forEach(item => {
            commit('setAdvancedAvailability', {
              availability: item.availability,
              variationId: item.variationId
            })
          })
        }
      } catch (error) {
        console.error('Fetch error:', error)
      } finally {
        commit('setIsAdvancedAvailabilityLoading', false)
      }
    }
  }
}

export default {
  state,
  mutations,
  actions
}
